export default "__VITE_ASSET__D9WwLJ5c__"